var _rect, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLatvia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "85.5 0 24 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    width: 24,
    height: 17,
    fill: "#fff",
    strokeWidth: 0.051149
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.046784 0 0 .049708 85.5 0)",
    fill: "#a2001d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 513,
    height: 127.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    y: 214.4,
    width: 513,
    height: 127.6
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatvia);
export default __webpack_public_path__ + "static/media/latvia.a7997cbfc58d6bd3791d4d5dc99926ad.svg";
export { ForwardRef as ReactComponent };